<template>
  <Card theme="pink">
    <h3>
      Gemiddeld stuur jij
      <PercentCircle>{{ percentage }}</PercentCircle>
      van jouw pakjes terug
    </h3>
    <p>Jij stuurt dus {{ comparedToText }} terug {{ alsDan }} de gemiddelde Nederlander. We sturen namelijk ongeveer {{ average }}% van onze bestelde pakjes weer terug, gemiddeld.</p>
  </Card>
</template>

<script>
import Card from '../Card'
import PercentCircle from '../PercentCircle'

export default {
  name: 'ThirdContent',
  components: {
    Card,
    PercentCircle
  },
  data () {
    return {
      average: 15
    }
  },
  props: {
    result: {
      type: Number,
      default: 0
    }
  },
  computed: {
    percentage () {
      return `${Math.ceil(this.result)}%`
    },
    comparedToText () {
      if (this.result === this.average) {
        return 'net zo veel'
      }
      if (this.result > this.average) {
        return 'meer'
      }
      return 'minder'
    },
    alsDan () {
      return (this.result === this.average) ? 'als' : 'dan'
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  z-index: 10;
}
</style>
